import "./Registration.css";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import img from "../../img/Learn-Islamic-Studies-Online-for-kids-and-Adults.png";

const Registration = () => {
  return (
    <div>
      <div className="registration-text text-white">
        <h1>Feel Free to Stay With Us</h1>
        <h4>Please Registration</h4>
      </div>
      <div className="d-flex container">
        <div className="container custom-from">
          <Form>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="First Name"
                  placeholder="Enter Your Frist Name"
                />
              </Form.Group>

              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="Last Name"
                  placeholder="Enter Your Frist Name"
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" placeholder="Enter email" />
              </Form.Group>

              <Form.Group as={Col} controlId="formGridPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" placeholder="Password" />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridCity">
                <Form.Label>City</Form.Label>
                <Form.Control />
              </Form.Group>

              <Form.Group as={Col} controlId="formGridState">
                <Form.Label>State</Form.Label>
                <Form.Select defaultValue="Choose...">
                  <option>Comilla</option>
                  <option>Chittagong</option>
                  <option>Dhaka</option>
                  <option>Rangpur</option>
                  <option>Rajshahi</option>
                  <option>Sylhet</option>
                  <option>Dinajpur</option>
                  <option>Mymensingh</option>
                  <option>Noakhali</option>
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} controlId="formGridZip">
                <Form.Label>Zip</Form.Label>
                <Form.Control />
              </Form.Group>
            </Row>

            <Form.Group className="mb-3" id="formGridCheckbox">
              <Form.Check
                type="checkbox"
                label="Agree With Terms and Conditions"
              />
            </Form.Group>

            <div className="col-12">
              <button type="submit" className="btn btn-primary">
                Registration
              </button>
            </div>
          </Form>
        </div>
        <div>
          <img src={img} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Registration;
